import HttpRequest from "@/api/axios";
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
const axios1 = new HttpRequest(process.env.VUE_APP_API_BASE_URL1);

export default {
    getBanners(data) {
        return axios.request({
            url: "match/banners",
            method: "get",
            params:data
        });
    },
    getList(data) {
        return axios1.request({
            url: "match",
            method: "get",
            params:data
        });
    },
    ossSignature(params){
        return axios.request({
            url: "api/oss-signature",
            method: "get",
            params,
            baseURL:process.env.VUE_APP_API_BASE_URL_MDC
        });
    }
}
